/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { PaginatedDocumented } from '../../models/paginated-documented';
import { TurniResDto } from '../../models/turni-res-dto';

export interface TurniControllerFindManyTurni$Params {
  /**
   * Page number to retrieve. If you provide invalid value the default page number will applied
   *
   * **Example:** 1
   *
   *
   * **Default Value:** 1
   */
  page?: number;

  /**
   * Number of records per page.
   *
   *
   * **Example:** 20
   *
   *
   *
   * **Default Value:** 20
   *
   *
   *
   * **Max Value:** 0
   *
   *
   * If provided value is greater than max value, max value will be applied.
   */
  limit?: number;

  /**
   * Parameter to sort by.
   * To sort by multiple fields, just provide query param multiple types. The order in url defines an order of sorting
   *
   * **Format:** {fieldName}:{DIRECTION}
   *
   *
   * **Example:** sortBy=id:DESC&sortBy=codice:DESC
   *
   *
   * **Default Value:** nome:ASC
   *
   * **Available Fields**
   * - id
   *
   * - codice
   *
   * - nome
   */
  sortBy?: Array<
    | 'id:ASC'
    | 'id:DESC'
    | 'codice:ASC'
    | 'codice:DESC'
    | 'nome:ASC'
    | 'nome:DESC'
  >;

  /**
   * Search term to filter result values
   *
   * **Example:** John
   *
   *
   * **Default Value:** No default value
   */
  search?: string;

  /**
   * List of fields to search by term to filter result values
   *
   * **Example:** id,codice,nome
   *
   *
   * **Default Value:** By default all fields mentioned below will be used to search by term
   *
   * **Available Fields**
   * - id
   *
   * - codice
   *
   * - nome
   */
  searchBy?: Array<string>;
}

export function turniControllerFindManyTurni(
  http: HttpClient,
  rootUrl: string,
  params?: TurniControllerFindManyTurni$Params,
  context?: HttpContext,
): Observable<
  StrictHttpResponse<
    PaginatedDocumented & {
      data?: Array<TurniResDto>;
      meta?: {
        select?: Array<string>;
        filter?: {};
      };
    }
  >
> {
  const rb = new RequestBuilder(
    rootUrl,
    turniControllerFindManyTurni.PATH,
    'get',
  );
  if (params) {
    rb.query('page', params.page, {});
    rb.query('limit', params.limit, {});
    rb.query('sortBy', params.sortBy, {});
    rb.query('search', params.search, {});
    rb.query('searchBy', params.searchBy, {});
  }

  return http
    .request(
      rb.build({ responseType: 'json', accept: 'application/json', context }),
    )
    .pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<
          PaginatedDocumented & {
            data?: Array<TurniResDto>;
            meta?: {
              select?: Array<string>;
              filter?: {};
            };
          }
        >;
      }),
    );
}

turniControllerFindManyTurni.PATH = '/admin/turni';
